var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewStrikerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 7.5C14.0625 9.05062 12.8006 10.3125 11.25 10.3125C9.69938 10.3125 8.4375 9.05062 8.4375 7.5C8.4375 5.94938 9.69938 4.6875 11.25 4.6875C12.8006 4.6875 14.0625 5.94938 14.0625 7.5ZM22.5 7.07906C22.5 7.07906 18.5138 15 11.2641 15C4.53281 15 0 7.07906 0 7.07906C0 7.07906 4.16813 0 11.2641 0C18.4772 0 22.5 7.07906 22.5 7.07906ZM15.9375 7.5C15.9375 4.91531 13.8347 2.8125 11.25 2.8125C8.66531 2.8125 6.5625 4.91531 6.5625 7.5C6.5625 10.0847 8.66531 12.1875 11.25 12.1875C13.8347 12.1875 15.9375 10.0847 15.9375 7.5Z",
    fill: "#CD2A3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewStrikerIcon);
export default __webpack_public_path__ + "static/media/viewStrikerIcon.889c8966e31c5a5183ad341e2fa4769c.svg";
export { ForwardRef as ReactComponent };